.radioFieldGroup_input {
  appearance: none;
  cursor: pointer;
  height: 24px;
  outline: none;
  position: relative;
  width: 24px;
  z-index: 1;
}

.radioFieldGroup_input:disabled {
  cursor: default;
}

.radioFieldGroup_input:focus-visible::after {
  border: 1px solid var(--colors-primary-main);
  bottom: -3px;
  background-color: transparent;
  content: '';
  border-radius: 50%;
  display: inherit;
  left: -3px;
  position: absolute;
  right: -3px;
  top: -3px;
}

.radioFieldGroup_input ~ div[role='presentation'] {
  background-color: var(--colors-grays-white);
  border: 2px solid var(--colors-grays-mid);
  border-radius: 50%;
  box-shadow: var(--shadows-inner);
  height: 24px;
  position: absolute;
  top: 0;
  width: 24px;
}

.radioFieldGroup_input ~ div[role='presentation']::after {
  border-radius: 50%;
  content: '';
  display: block;
  height: 12px;
  left: 6px;
  position: absolute;
  top: 6px;
  width: 12px;
}

.radioFieldGroup_input:checked ~ div[role='presentation'] {
  background-color: var(--colors-primary-main);
  border: none;
  box-shadow: none;
}

.radioFieldGroup_input:checked ~ div[role='presentation']::after {
  background-color: var(--colors-grays-white);
}
